import React, { Component } from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';
import rootReducer from './store/reducers/index';
import PrivateRoute from './utils/PrivateRoute';
import Modal from './components/Modal';
import Loader from './components/Loader';
import Main from './pages/Main';
import ListContainer from './pages/List/ListContainer';
import DetailContainer from './pages/Detail/DetailContainer';
import SimulatorContainer from './pages/Simulation/Simulator/SimulatorContainer';
import ResultOptionsContainer from './pages/Simulation/ResultOptions/ResultOptionsContainer';
import ResultContainer from './pages/Simulation/Result/ResultContainer';
import SummaryContainer from './pages/Simulation/Summary/SummaryContainer';
import LiquidateContainer from './pages/Liquidate/LiquidateContainer';
import './app.css';

require('dotenv').config();

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f
  )
);

class App extends Component {
  constructor() {
    super();
    ReactGA.initialize('UA-84474192-2');
  }

  componentDidMount() {
    // Cambia el height del iFrame en TEF
    setInterval(() => {
      window.top.postMessage(
        { scrollHeight: document.body.scrollHeight + 30},
        process.env.REACT_APP_PARENT_DOMAIN
      );
    }, 1000);
  }

  render() {
    return (
      <Provider store={store}>
        <Loader />
        <BrowserRouter>
        <div>
          <Switch>
            <Route exact path="/" component={Main} />
            <PrivateRoute path="/simulador" component={SimulatorContainer} />
            <PrivateRoute
              path="/resultado-opciones"
              component={ResultOptionsContainer}
            />
            <PrivateRoute
              path="/resultado-seleccion"
              component={ResultContainer}
            />
            <PrivateRoute path="/resumen" component={SummaryContainer} />
            <PrivateRoute path="/listado" component={ListContainer} />
            <PrivateRoute path="/detalle" component={DetailContainer} />
            <PrivateRoute path="/liquidar" component={LiquidateContainer} />
          </Switch>
          <Modal/>
          </div>
        </BrowserRouter> 
      </Provider>
    );
  }
}

export default App;
